<template><div><h1 id="ereignissituationen" tabindex="-1"><a class="header-anchor" href="#ereignissituationen"><span>Ereignissituationen</span></a></h1>
<p>Ereignissituationen — Definition der Ereignissituationen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Tabelle ist im System fix definiert und kann nur durch ARENAE verändert werden. Die wichtigsten Ereignissituationen folgen weiter unten.</p>
<table>
<thead>
<tr>
<th>Situation</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>RSB</td>
<td>Zusageneinzahlung (vereinnahmt)</td>
</tr>
<tr>
<td>RSS</td>
<td>Spendeneinzahlung (vereinnahmt)</td>
</tr>
<tr>
<td>RWV</td>
<td>Fakturierter Warenumsatz</td>
</tr>
</tbody>
</table>
<p>Die Spalten haben folgende Bedeutung: Wenn in der Spalte ein &quot;U&quot; steht, können die unten angegebenen Felder im Ereigniskopf und/oder in der Ereignisposition eingegeben werden. Wenn die Spalten leer sind, können die entsprechenden Felder bei der Erfassung des Ereignisses nicht geändert werden.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Tabellen → Ereignissituationen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Situation</dt>
<dd>Code der Ereignissituation</dd>
<dt>Bezeichnung</dt>
<dd>Beschreibung der Ereignissituation</dd>
<dt>Kto/Kst/ktr</dt>
<dd>U = Felder Konto, Kostenstelle, Kostenträger und Umsatztyp im Ereigniskopf editierbar</dd>
<dt>Fremd-DB</dt>
<dd>U = Fremddatenbanknummer in den Ereignispositionen editierbar</dd>
<dt>Initialdatum</dt>
<dd>U = Initialdatum im Ereigniskopf editierbar</dd>
<dt>Zusage</dt>
<dd>U = Zusage im Ereigniskopf editierbar</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>keine</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.ereigkopf.html" title="Ereignisse">Ereigniskopf</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.ereigpos.html" title="Ereignispositionen">Ereignispositionen</RouteLink></p>
</div></template>


